import { API_URL_AWARD } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";
import TCreateEditAward from "types/Award/createEditAward";

const updateAward = (uuid: string, editedItem: TCreateEditAward) =>
  apiInstance({
    url: API_URL_AWARD + uuid,
    method: "put",
    data: editedItem,
  });

export default updateAward;
